import { localstorageAvailable } from '../../services/services';

const acceptPolicy = () => {
  if (localstorageAvailable()) {
    localStorage.setItem('accept_cookies_policy', 'true');
  } else {
    document.cookie = 'accept_cookies_policy=true';
  }
  document.getElementById('cookies-notification').className = 'hidden';
};

const ShowCookiesNotification = () => {
  document.getElementById('cookies-notification').className = 'visible';
};

const closeCookiesButton = document.getElementById('close-cookies-button');
if (closeCookiesButton) {
  closeCookiesButton.onclick = acceptPolicy;
}

(() => {
  if (localstorageAvailable()) {
    if (!localStorage.accept_cookies_policy) {
      ShowCookiesNotification();
    }
  } else {
    if (document.cookie.indexOf('accept_cookies_policy') == -1) {
      ShowCookiesNotification();
    }
  }
})();



// WEBPACK FOOTER //
// ./app/javascript/layout/components/cookies.js